export default __webpack_public_path__ + "static/media/comic6.3a593494.png";